import { render, staticRenderFns } from "./modalConfigurarPagos.vue?vue&type=template&id=7d84895e&scoped=true"
import script from "./modalConfigurarPagos.vue?vue&type=script&lang=js"
export * from "./modalConfigurarPagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d84895e",
  null
  
)

export default component.exports